import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { UserCreators } from "redux/modules/user";
import { useNavigate } from "react-router-dom";
import styled from "styled-components";

import authCheck from "components/common/useAuthCheck";

import { MyPageHead } from "../common/index";

import { EachContent } from "../common/style";

import arrow from '../../../../assets/icons/arrow-right.svg';



const Setting = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const [auth, setAuth] = useState(false)

  React.useEffect(() => {
    const enter = authCheck('NORMAL')
    if (enter === true) {
      setAuth(true)
    } else {
      navigate('/login')
    }
  }, [auth]);

  const logout = () => {
    dispatch(UserCreators.kakaoUnlink())
    navigate('/login')
  }

  return auth === 'NONE' ? navigate('/login') : (
      <WholeWrapper>
        <MyPageHead title="설정"/>
        <AgreeContainer>
          <EachContent onClick={() => navigate('/notice/tos')}>
            <Content>서비스 이용 약관</Content>
            <Arrow src={arrow} />
          </EachContent>
          <EachContent onClick={() => navigate('/notice/pp')}>
            <Content>개인정보처리방침</Content>
            <Arrow src={arrow} />
          </EachContent>
          <EachContent onClick={logout}>
            <Content>로그아웃</Content>
            <Arrow src={arrow} />
          </EachContent>
          <EachContent onClick={() => navigate('/mypage/secession')}>
            <Content>탈퇴하기</Content>
            <Arrow src={arrow} />
          </EachContent>
        </AgreeContainer>
      </WholeWrapper>
  )
}

const WholeWrapper = styled.div`
  width: 100%;
  height: calc(100% - 25px);
  margin: auto;
  position: relative;
`;

const AgreeContainer = styled.div`
  width: 90%;
  margin: 0px auto;
  padding-top: 10px;
`

const Content = styled.div`
  margin-left: 10px;
`

const Arrow = styled.img`
  width: 1.5rem;
`

export default Setting;